import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"linkedin\"><path fill-rule=\"evenodd\" d=\"M0 24h5V8H0zM0 3a3 3 0 1 0 6 0 3 3 0 0 0-6 0m12.99 7.52h-.07V8.4H8V24h5.13v-7.72c0-2.04.4-4.01 3.07-4.01 2.64 0 2.67 2.33 2.67 4.14V24H24v-8.56c0-4.2-.96-7.44-6.15-7.44-2.5 0-4.18 1.3-4.86 2.52\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol